import {SpecItemDocInvoice} from '../../../../../interface';
import './invoice.scss';
import {Button, IconButton} from '@mui/material';
import {AppTableView} from '../../../../../components/app-table-view/app-table-view';
import {ReactComponent as DownloadIcon} from '../../../../../assets/img/icon/download.svg';
import React, {useEffect, useRef, useState} from 'react';
import {ExpandLess} from '@mui/icons-material';
import {ReactComponent as BookIcon} from '../../../../../assets/img/icon/book.svg';
import {ScrollToTop} from '../../../../../ui/scroll-to-top/scroll-to-top';
import {StickyDownloadButton} from '../../../../../ui/sticky-download-button/sticky-download-button';


interface InvoiceProps {
    invoice: SpecItemDocInvoice
    specId: string;
}

const Invoice = ({invoice, specId}: InvoiceProps) => {

    return <>
        <StickyDownloadButton  style={{margin: '0 -24px 0 0px'}} hideNotStickyWrapper={true}>
            <Button
                variant="outlined"
                startIcon={<DownloadIcon/>}
                href={`/api/spec/${specId}/command/export/excel`}
                download>
                Скачать...
            </Button>
        </StickyDownloadButton>
        <div className="specification-invoice">
            <div className={'specification-invoice__table'}>
                <AppTableView data={invoice}/>
            </div>
        </div>
    </>;
};

export {Invoice};
